module.exports = __webpack_public_path__ + "img/naalaim_yes.267e26cd.png";